import "./index.less";
import GuessModel from "../GuessModel";
import ChatStore from "@/store/chat.store";
import { MessageSource } from "@/services/api_question";

interface AIInputProps {
  onChange: (v: string) => void;
  onConfirm: (v: string, source: MessageSource) => void;
}

const AITip: React.FC<AIInputProps> = (props) => {
  const geussQuestions = ChatStore((state) => state.geussQuestions);
  const { onChange, onConfirm } = props;

  const handleChoose = (question: string) => {
    onChange(question);
    onConfirm(question, MessageSource.QUESTION_LIB);
  };

  return (
    <div className="AITip">
      <div className="tip-title title-text">👋 HI，我是AI会议助手</div>
      <div className="tip-content content-text">我擅长理解并回答与会议内容相关的问题，帮你更好地掌握知识～</div>
      <GuessModel questionList={geussQuestions} showCount={3} onChooseQuestion={handleChoose} />
    </div>
  );
};

export default AITip;
